import React from 'react';
import { Button, Col, Row, Spin, Switch, Typography } from 'components';
import { NotificationCard } from 'feature/dashboardTabs/notification/notificationCard';
import { useNotificationPage } from 'feature/dashboardTabs/notification/useNotificationPage';
import { LoadingOutlined } from '@ant-design/icons';

export const Notification = React.memo(() => {
  const {
    unreadCount,
    // setUnreadOnly,
    notifications,
    handleAllReadChange,
    firstNotificationRef,
    lastNotificationRef,
    isLoading,
    isFetchingNextPage,
  } = useNotificationPage();
  return (
    <Col span={24}>
      <Spin spinning={isLoading} indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}>
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Row align={'middle'} justify={'space-between'}>
              <Col>
                <Typography.Title level={5} className={'reset-title'}>
                  Notifications
                </Typography.Title>
              </Col>
              <Col>
                <Row align={'middle'} gutter={18}>
                  <Col>
                    <Row align={'middle'} className={'gap-4'}>
                      <Typography.Text>Unread only</Typography.Text>
                      <Switch
                      // onChange={() => {
                      //   setUnreadOnly((prevState) => !prevState);
                      // }}
                      />
                    </Row>
                  </Col>
                  {!!unreadCount && (
                    <Col>
                      <Button
                        size={'small'}
                        type={'text'}
                        variant={'text'}
                        className={'underline-button'}
                        onClick={handleAllReadChange}
                      >
                        <Typography.Text underline style={{ color: '#05796B' }}>
                          Mark All as Read
                        </Typography.Text>
                      </Button>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 12]}>
              {notifications.map((_data, index) => {
                return (
                  <NotificationCard
                    key={_data.id}
                    data={_data}
                    notificationRef={
                      index === 0
                        ? firstNotificationRef
                        : index === notifications?.length - 1
                          ? lastNotificationRef
                          : undefined
                    }
                  />
                );
              })}
            </Row>
          </Col>
          <Col>
            <Row justify={'center'} className={'margin-b-16'}>
              <Col span={24}>
                <Spin
                  spinning={isFetchingNextPage}
                  tip={'Loading Notifications...'}
                  indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
                >
                  <div />
                </Spin>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </Col>
  );
});
